import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelInformes(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <h1>Panel Informes</h1>
            
            </div>



        </Fragment>
    );
};


export default withRouter(PanelInformes)
